import axios from 'axios';
import axios2 from '../../../setupAxiosV2';

export function fetchUserInfo() {
  return axios2.get('/config/school-config');
}

